export enum ContractStatusEnum {
        Approved = 12,
        Completed = 13,
        Pending = 14,
        Rejected = 15,
}